<div class="adc-dropdown" *ngIf="type=='basic'" ngClass="{{ data.customClass }}">
  <label>{{ data.label }}</label> 
  <button (click)="dropdown1()">Menu<span class="adc-align-self-center adc-mt5">
    <!-- <mat-icon >{{data.icon}}</mat-icon> -->
    <img [src]="data.icon" *ngIf="data.showIcon" [ngClass]="showDropdown ? 'adc-dropdownOpen' : ''" style="line-height: 1.2;" alt="" width="20px" height="20px">
  </span></button>
  <div appendTo="body" *ngIf="showDropdown">
    <a (click)="dropdown1()">Edit</a>
    <a (click)="dropdown1()">Rename</a>
    <a (click)="dropdown1()">Delete</a>  
  </div>
</div>
 
<div *ngIf="type=='select'">
  <label>{{ data.label }}</label>
  <select class="adc-select" (change)="onSelected($event)" ngClass="{{ data.customClass }}">
    <option value="option1" *ngFor="let i of data.list">{{i.label}}</option>
    <!-- <option value="option2">Open</option>
    <option value="option3">Close</option>
    <option value="option4">Pending</option> -->
  </select>
</div>
 
<div class="adc-dropdown" *ngIf="type=='search'" ngClass="{{ data.customClass }}">
  <label>{{ data.label }}</label> 
  <button (click)="dropdown2($event)">
    <span *ngIf="!showSelected">Dropdown</span>
    <span *ngIf="showSelected">{{showSelected}}</span>
    <span class="adc-align-self-center adc-mt5">
      <!-- <mat-icon *ngIf="data.showIcon" [ngClass]="showDropdown ? 'adc-dropdownOpen' : ''">{{data.icon}}</mat-icon> -->
      <img [src]="data.icon" *ngIf="data.showIcon" [ngClass]="showDropdown ? 'adc-dropdownOpen' : ''" style="line-height: 1.2;" alt="" width="20px" height="20px">
    </span>
  </button>
  <div appendTo="body" *ngIf="showDropdown">
    <a>
      <div class="adc-srh adc-d-flex adc-align-items-center adc-position-relative">
        <input type="text" name="" id="" class="adc-form-control adc-textbox adc-pr40" (keyup)="search($event)" placeholder="Search..">
        <!-- <img src="../../../assets/icons/search.png" class="adc-size-15 adc-position-absolute" style="right: 15px;"> -->
        <img [src]="data.icon" *ngIf="data.showIcon" [ngClass]="showDropdown ? 'adc-dropdownOpen' : ''" class="adc-position-absolute" style="right: 0px; top: 8px; font-size: 18px; transform: rotate(0deg)" alt="" width="20px" height="20px">
        <!-- <mat-icon [ngClass]="showDropdown ? 'adc-dropdownOpen' : ''" class="adc-size-15 adc-position-absolute" style="right: 0px; top: 8px; font-size: 18px; transform: rotate(0deg)">search</mat-icon> -->
    </div>
      <!-- <input type="text" class="adc-form-control adc-w-75" (keyup)="search($event)" name="" id=""> -->
    </a>
    <a *ngFor="let i of showOption" (click)="selected(i.label)">{{ i.label }}</a>  
  </div>
</div>
 
<div class="adc-dropdown-mul" *ngIf="type=='multiselect'" ngClass="{{ data.customClass }}">
  <label>{{ data.label }}</label> 
  <button class="adc-ellipsis" (click)="dropdown2($event)">
    <span *ngIf="selectedOption.length == 0">Dropdown</span>
    <span *ngIf="selectedOption.length != 0" class="adc-ellipsis adc-t-al adc-d-flex">
      <span *ngFor="let i of data.list" class="adc-d-flex adc-flex-nowrap" title="{{selectedOption}}">
        <span *ngIf="i.isSelected">{{i.label}},
          <!-- <mat-icon class="adc-dropdown-icon" (click)="multiSelect(i)">cancel</mat-icon> -->
        </span>
      </span>
    </span>
    <!-- <span class="" *ngIf="showMultiSelect">{{ noOfOptions }}</span> -->
    <div class="adc-p3" style="color: white; border: 1px solid white; border-radius: 100%; min-width: 15px;" *ngIf="selectedOption.length != 0">
      <label>{{ selectedOption.length }}</label>
    </div>
    <span class="adc-align-self-center adc-mt5">
      <!-- <img src="../../../assets/down-arrow (1).png" alt="downarrow" [ngClass]="showDropdown3 ? 'adc-dropdownOpen' : ''"> -->
      <!-- <mat-icon *ngIf="data.showIcon" [ngClass]="showDropdown ? 'adc-dropdownOpen' : ''">{{data.icon}}</mat-icon> -->
      <img [src]="data.icon" *ngIf="data.showIcon" [ngClass]="showDropdown ? 'adc-dropdownOpen' : ''" alt="" width="20px" height="20px">
    </span>
  </button>
  <div appendTo="body" *ngIf="showDropdown">
    <!-- <a> -->
    <a class="adc-chk" *ngFor="let i of data.list">
      <input type="checkbox" value="" id="flexCheckDefault1" (click)="multiSelect(i)" [(ngModel)]="i.isSelected">
      <label for="flexCheckDefault1">
        {{ i.label }}
      </label>
    </a>
    <!-- <input type="checkbox" class="adc-chk" name="" id="" >  -->
  <!-- </a>   -->
  </div>
</div>

<div class="adc-dropdown-mul" *ngIf="type=='multisearch'" (clickOutside)="showDropdown_ = false" #dropdownRef>
  <label>{{ data.label }}</label> 
    <button class="adc-ellipsis" (click)="dropdown($event)">
      <span class="adc-ellipsis adc-t-al adc-d-flex">
        <span *ngFor="let i of data.list" class="adc-d-flex adc-flex-nowrap" title="{{selectedOption}}"> 
          <span *ngIf="i.isSelected">{{i.name}}, 
          </span>
        </span>
      </span> 
      <div class="adc-p3" style="color: white !important; border: 1px solid white; border-radius: 100%; min-width: 20px;" *ngIf="selectedOption.length != 0">
        <label>{{ selectedOption.length }}</label>
      </div>
      <span class="adc-align-self-center adc-mt5">
        <mat-icon [ngClass]="showDropdown_ ? 'adc-dropdownOpen' : ''">keyboard_arrow_down</mat-icon>
      </span>
    </button>
    <div appendTo="body" *ngIf="showDropdown_">
        <a>
          <div class="adc-srh adc-d-flex adc-align-items-center adc-position-relative"> 
            <input type="text" name="" id="" class="adc-form-control adc-textbox adc-pr40" (keyup)="search($event)" placeholder="Search..">
            <mat-icon [ngClass]="showDropdown_ ? 'adc-dropdownOpen' : ''" class="adc-size-15 adc-position-absolute" style="right: 0px; top: 8px; font-size: 18px;">search</mat-icon>
        </div>
        </a>
      <a class="adc-chk" *ngFor="let i of showOption">
        <input type="checkbox" value="" id="flexCheckDefault1" (click)="multiSelect(i)" [(ngModel)]="i.isSelected">
        <label for="flexCheckDefault1">
          {{ i.name }}
        </label>
      </a>
    </div>
</div>

<div class="adc-dropdown" *ngIf="type=='categorized'" (clickOutside)="showDropdown = false" #dropdownRef>
  <label >{{ data.label }}</label>
   <select class="adc-select" (change)="onSelected($event)">
       <optgroup *ngFor="let group of data.options" [label]="group.name">
         <option *ngFor="let i of group.children" [value]="i.name">
             {{ i.name }}
         </option>
       </optgroup>
    </select>
</div>